export const defaultQueryParamName = 'query';
export const defaultSortParamName = 'sort';
export const defaultTakeParamName = 'take';

export const getDefaultMultiListSortParamName = (listKey: string) =>
  `${defaultSortParamName}-${listKey}`;

export const getDefaultMultiListTakeParamName = (listKey: string) =>
  `${defaultTakeParamName}-${listKey}`;
